import React, { useState } from "react";
import {
  Grid,
  Typography,
  Button,
  Box,
  TextField,
  Fade,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";

// styles
import useStyles from "./styles";

// context
import { useUserDispatch, loginUser } from "../../context/UserContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Login(props) {
  var classes = useStyles();

  // global
  var userDispatch = useUserDispatch();

  // local
  var [isLoading, setIsLoading] = useState(false);
  var [error, setError] = useState(null);
  var [activeTabId, setActiveTabId] = useState(0);
  var [nameValue, setNameValue] = useState("");
  var [loginValue, setLoginValue] = useState("");
  var [passwordValue, setPasswordValue] = useState("");
  const [buttonLoader, setbuttonLoader] = useState(false);

  // const handleToastClick = () => {
  //   toast.success("Login Successful!", {
  //     position: "top-right",
  //     autoClose: 5000,
  //     pauseOnHover: true,
  //     theme: "light",
  //   });
  // };

  return (
    <Grid container className={classes.container}>
      <div className={classes.logotypeContainer}>
        {/* <img src={logo} alt="logo" className={classes.logotypeImage} /> */}
        <img
          src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1747293376/beleaf_dark_raisfz.webp"
          alt="logo"
          className={classes.logotypeImage}
        />
        {/* <Typography className={classes.logotypeText}>Admin</Typography> */}
      </div>
      <div className={`${classes.formContainer} login_right_container`}>
        <div className={classes.form}>
          <Box
            sx={{
              width: "100%",
              mx: "auto",
              mt: 5,
              p: 4,
              boxShadow: 3,
              borderRadius: 2,
            }}
          >
            <Typography
              className={classes.admin_login_header}
              variant="h5"
              align="center"
              gutterBottom
              // onClick={handleToastClick}
            >
              Admin Login
            </Typography>
            <div className={classes.whole_div_login}>
              {/* Error message */}
              <Fade in={error}>
                <Typography color="error" sx={{ mt: 2 }}>
                  Something is wrong with your login or password :(
                </Typography>
              </Fade>
              <Typography
                fullWidth
                color="inherit"
                // className={classes.forgetButton}
                variant="body2"
                sx={{ mt: 1 }}
              >
                Email
              </Typography>
              {/* Email Field */}
              <TextField
                id="email"
                label="Email Address"
                variant="outlined"
                type="email"
                fullWidth
                value={loginValue}
                onChange={(e) => setLoginValue(e.target.value)}
                // margin="normal"
                className={classes.margin_bothinput}
              />

              <Typography
                fullWidth
                color="inherit"
                // className={classes.forgetButton}
                variant="body2"
                sx={{ mt: 1 }}
              >
                Password
              </Typography>

              {/* Password Field */}
              <div className="login_password_wrap">
                <TextField
                  id="password"
                  label="Password"
                  variant="outlined"
                  type="password"
                  fullWidth
                  value={passwordValue}
                  onChange={(e) => setPasswordValue(e.target.value)}
                  // margin="normal"
                  className={`${classes.margin_bothinput} my-0`}
                />
                <span className="eye_icon_wrap">
                  {/* <i className="fa-solid fa-eye"></i> */}
                  <i class="fa-solid fa-eye-slash"></i>
                </span>
              </div>
              {/* <Typography
                fullWidth
                color="primary"
                className={classes.forgetButton}
                variant="body2"
                sx={{ mt: 1 }}
              >
                Forget Password?
              </Typography> */}

              {/* Login Button */}
              <Box sx={{ mt: 2 }}>
                {buttonLoader === false ? (
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    size="large"
                    disabled={!loginValue || !passwordValue}
                    onClick={() =>
                      loginUser(
                        userDispatch,
                        loginValue,
                        passwordValue,
                        props.history,
                        setIsLoading,
                        setError,
                      )
                    }
                  >
                    Login
                  </Button>
                ) : (
                  <Button variant="contained" fullWidth disabled>
                    Loading...
                  </Button>
                )}

                {/* Forgot Password */}
              </Box>
            </div>
          </Box>
        </div>
      </div>
    </Grid>
  );
}

export default withRouter(Login);
